export function offerSearchTextDistrict({
    district
}: {
    district?: {
        title?: string;
        titleShort?: string;
        locativeName?: string;
    };
}) {
    if (! district) return '';
    const title = district.titleShort || district.title;

    if (! title) return '';

    const locativeName = district.titleShort ? `в ${district.titleShort}` : district.locativeName;

    return `${locativeName || title}`;
}
